import Ontology from './Ontology';

export default Ontology;